<template>
  <div class="full-height">
    <div class="full-height full-width">
      <AdminHeader
        title="Account Management"
        icon="mdi-cog-outline"
        iconColor="brand"
        :elevation="1"
        :showSearch="false"
        :showAddClient="isWhistleAdmin"
        @add-client="handleAddClientClick"
      />
      <v-row class="my-2">
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card
            class="text-left d-flex flex-column justify-start py-3 rounded-lg"
            :class="isMobile ? 'full-width mb-3' : 'mb-10'"
            :style="{ 'min-height': '100%' }"
          >
            <!-- Disable if there are no not deleted programs for their client -->
            <v-btn
              v-if="showCompanyTab"
              class="mx-3 d-flex justify-space-between view-button"
              color="white"
              depressed
              :class="tab == keys.company ? 'highlighted-button' : ''"
              @click="handleTabChange(keys.company)"
            >
              Company Info
              <v-icon large color="grey">mdi-chevron-right</v-icon>
            </v-btn>
            <v-divider v-if="showCompanyTab" class="mx-1" />
            <v-btn
              v-if="showCompanyTab"
              class="mx-3 d-flex justify-space-between view-button"
              color="white"
              depressed
              :class="tab == keys.customization ? 'highlighted-button' : ''"
              @click="handleTabChange(keys.customization)"
            >
              Customization
              <v-icon large color="grey">mdi-chevron-right</v-icon>
            </v-btn>
            <v-divider v-if="showCompanyTab" class="mx-1" />
            <v-btn
              class="mx-3 d-flex justify-space-between view-button"
              depressed
              color="white"
              :class="tab == keys.documents ? 'highlighted-button' : ''"
              @click="handleTabChange(keys.documents)"
            >
              Documents
              <v-icon large color="grey">mdi-chevron-right</v-icon>
            </v-btn>
            <v-divider class="mx-1" />
            <v-btn
              v-if="isWhistleAdmin"
              class="mx-3 d-flex justify-space-between view-button"
              depressed
              color="white"
              :class="tab == keys.procore ? 'highlighted-button' : ''"
              @click="handleTabChange(keys.procore)"
            >
              Procore
              <v-icon large color="grey">mdi-chevron-right</v-icon>
            </v-btn>
            <v-divider v-if="isWhistleAdmin" class="mx-1" />
            <v-btn
              v-if="isWhistleAdmin"
              class="mx-3 d-flex justify-space-between view-button"
              depressed
              color="white"
              :class="tab == keys.cron ? 'highlighted-button' : ''"
              @click="handleTabChange(keys.cron)"
            >
              CRON Manager
              <v-icon large color="grey">mdi-chevron-right</v-icon>
            </v-btn>
            <v-divider v-if="isWhistleAdmin" class="mx-1" />
            <v-btn
              v-if="showMarqetaKYBTab"
              class="mx-3 d-flex justify-space-between view-button"
              depressed
              color="white"
              :class="tab == keys.kyb ? 'highlighted-button' : ''"
              @click="handleTabChange(keys.kyb)"
            >
              KYB Manager
              <v-icon large color="grey">mdi-chevron-right</v-icon>
            </v-btn>
            <v-divider v-if="showMarqetaKYBTab" class="mx-1" />
            <v-btn
              v-if="showCompanyTab"
              class="mx-3 d-flex justify-space-between view-button"
              depressed
              color="white"
              :class="tab == keys.finch ? 'highlighted-button' : ''"
              @click="handleTabChange(keys.finch)"
            >
              Employee Data Integrations
              <v-icon large color="grey">mdi-chevron-right</v-icon>
            </v-btn>
            <v-divider v-if="showCompanyTab" class="mx-1" />

            <v-btn
              v-if="showDataIntegrationTab"
              class="mx-3 d-flex justify-space-between view-button"
              depressed
              color="white"
              :class="tab == keys.prism ? 'highlighted-button' : ''"
              @click="handleTabChange(keys.prism)"
            >
              Channel Data Integrations
              <v-icon large color="grey arrow-top-right" style="font-size: 30px"
                >mdi-arrow-top-right</v-icon
              >
            </v-btn>
            <v-divider v-if="showDataIntegrationTab" class="mx-1" />
            <v-btn
              v-if="showDeveloperSettingsTab"
              class="mx-3 d-flex justify-space-between view-button"
              depressed
              color="white"
              :class="tab == keys.developerSettings ? 'highlighted-button' : ''"
              @click="handleTabChange(keys.developerSettings)"
            >
              Developer Settings
              <v-icon large color="grey">mdi-chevron-right</v-icon>
            </v-btn>
            <v-divider v-if="showDeveloperSettingsTab" class="mx-1" />
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="8" lg="9" :key="globalClientId">
          <CompanyInfo
            v-if="tab == keys.company"
            :isMobile="isMobile"
            :client="currentClient"
            @getClient="getClients"
          />
          <Customization
            v-else-if="tab == keys.customization"
            :isMobile="isMobile"
            :client="currentClient"
            @getClient="getClients"
          />
          <Documents v-else-if="tab == keys.documents" :isMobile="isMobile" />
          <v-card v-else-if="tab == keys.finch" class="pa-3 rounded-lg">
            <v-card-title class="font-weight-bold">Integrations</v-card-title>
            <integrations-manager
              :alert="alert"
              :get-providers="getFinchProviders"
              :finch-disconnect="finchDisconnect"
              :finch-connect="finchConnect"
              :finch-resync="finchResync"
            />
          </v-card>
          <v-card v-else-if="tab == keys.procore" class="pa-3 rounded-lg">
            <v-card-title class="font-weight-bold">Procore</v-card-title>
            <procore-manager />
          </v-card>
          <v-card v-else-if="tab == keys.presets" class="pa-3 rounded-lg">
            <presets-manager />
          </v-card>
          <CRON v-else-if="tab == keys.cron" :isMobile="isMobile" />
          <!-- <v-card v-else-if="tab == keys.robin" class="pa-3 rounded-lg">
            <v-card-title class="font-weight-bold">Robin Manager</v-card-title>
            <RecommendationManager />
          </v-card> -->
          <v-card v-else-if="tab == keys.kyb" class="pa-3 rounded-lg">
            <MarqetaKYBManager />
          </v-card>
          <DeveloperSettings
            v-else-if="tab == keys.developerSettings"
            ref="developerSettings"
            :client="currentClient"
            @getClient="getClients"
          />
          <ChannelDataIntegrations
            v-else-if="tab == keys.prism"
            @close="handleChannelIntegrationsClose"
          />
        </v-col>
      </v-row>
    </div>
    <!-- Nav drawer for adding clients -->
    <v-navigation-drawer v-model="dialog.createClient" temporary fixed right width="500">
      <ClientCreatorWidget
        v-if="dialog.createClient"
        @close="dialog.createClient = false"
        @get-clients="getClients"
      />
    </v-navigation-drawer>
    <!-- Dialog used for displaying loading message. -->
    <LoadingDialog
      :showDialog="showLoadingDialog"
      :header="loadingHeaderMessage"
      :line1="loadingMessageLine1"
      :line2="loadingMessageLine2"
    ></LoadingDialog>

    <v-dialog v-model="showDialog" width="512">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2 py-4">
          {{ dialogOpts.title }}
        </v-card-title>

        <v-card-text class="py-4">
          <strong>{{ dialogOpts.body }}</strong>
        </v-card-text>

        <!-- <v-divider></v-divider> -->

        <v-card-actions class="pt-3 pb-5">
          <v-spacer></v-spacer>
          <v-btn
            v-if="dialogOpts.cancellable"
            color="brandCyan"
            width="130"
            outlined
            depressed
            @click="showDialog = false"
            class="mr-3"
          >
            Cancel
          </v-btn>
          <v-btn
            :color="dialogOpts.okColor || 'brandCyan'"
            width="130"
            :class="(dialogOpts.okColor || 'brandCyan') == 'brandCyan' ? 'white--text' : ''"
            depressed
            @click="dialogOpts.okAction"
          >
            OK
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AdminHeader from "@/components/Header/Header.vue";
import LoadingDialog from "@/components/loadingDialog.vue";
import CompanyInfo from "@/components/account-management/CompanyInfo.vue";
import Customization from "@/components/account-management/CompanyCustomization.vue";
import Documents from "@/components/account-management/Documents.vue";
import CRON from "@/components/account-management/CRON.vue";
// import RecommendationManager from "@/components/account-management/RecommendationManager.vue";
import MarqetaKYBManager from "@/components/account-management/MarqetaKYBManager.vue";
import IntegrationsManager from "@/components/account-management/Integrations.vue";
import ProcoreManager from "@/components/account-management/Procore.vue";
import ClientCreatorWidget from "@/components/account-management/ClientCreatorWidget.vue";
import ChannelDataIntegrations from "../components/account-management/ChannelDataIntegrations.vue";
import DeveloperSettings from "@/components/account-management/DeveloperSettings.vue";

import isWhistleAdmin from "@/mixins/isWhistleAdmin";
import ClientServiceV2 from "@/services/ClientServiceV2";
import axios from "axios";
import { formRules } from "@/shared_data/data";
import { mapState, mapGetters } from "vuex";

export default {
  name: "AccountManagement",
  title: "Account Management",
  components: {
    AdminHeader,
    LoadingDialog,
    // RecommendationManager,
    MarqetaKYBManager,
    CompanyInfo,
    Customization,
    ProcoreManager,
    IntegrationsManager,
    Documents,
    ClientCreatorWidget,
    ChannelDataIntegrations,
    CRON,
    DeveloperSettings,
  },
  mixins: [isWhistleAdmin],
  data() {
    return {
      clientService: new ClientServiceV2(),

      //  Page Management
      tab: 0,
      keys: {
        company: 0,
        customization: 1,
        reporting: 2,
        finch: 3,
        procore: 4,
        procoreKickoff: 5,
        presets: 6,
        documents: 7,
        clients: 9,
        cron: 10,
        // robin: 11,
        kyb: 12,
        developerSettings: 13,
        prism: 14,
      },
      formRules,

      // Loading Dialog
      showLoadingDialog: false,
      loadingHeaderMessage: null,
      loadingMessageLine1: null,
      loadingMessageLine2: null,

      // Dialogs
      showDialog: false,
      dialogOpts: {
        title: "",
        body: "",
      },
      dialog: {
        createClient: false,
      },

      // Loading
      loading: {
        clients: false,
      },

      // Clients / State
      clients: [],
      currentClientId: null,
    };
  },

  created() {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has("code")) {
      const code = searchParams.get("code");
      this.finishFinchConnect(code);
    }
    if (this.hasPermissionToViewClients()) {
      this.getClients({ page: 0 });
    }
  },
  async beforeRouteLeave(to, from, next) {
    const canLeave = await this.confirmCanLeaveDeveloperSettings();
    next(canLeave);
  },
  methods: {
    /**
     * Lets DeveloperSettings (and, transitively, InformSettings) gate
     * navigation away when there are unmapped required Inform fields. Returns
     * true when no gate is active or the user explicitly confirms.
     */
    async confirmCanLeaveDeveloperSettings() {
      if (this.tab !== this.keys.developerSettings) return true;
      if (!this.$refs.developerSettings) return true;
      return this.$refs.developerSettings.confirmCanLeave();
    },
    async handleTabChange(tab) {
      if (tab === this.tab) return;
      const canLeave = await this.confirmCanLeaveDeveloperSettings();
      if (!canLeave) return;
      this.tab = tab;
    },
    handleChannelIntegrationsClose() {
      this.tab = this.keys.company;
    },
    handleAddClientClick() {
      this.dialog.createClient = true;
    },
    alert({ title, body, okAction, okColor, cancellable }) {
      this.dialogOpts.title = title;
      this.dialogOpts.body = body;
      this.dialogOpts.cancellable = cancellable || false;
      this.dialogOpts.okAction = () => {
        okAction && okAction();
        this.showDialog = false;
      };
      this.dialogOpts.okColor = okColor || "brandCyan";
      this.showDialog = true;
    },
    async finchDisconnect(data) {
      const disconnectResult = await axios.post(
        process.env.VUE_APP_OAUTH_SVC_BASE_URI + "/finch/disconnect/" + data.clientSupplementalId,
        {
          token: this.$store.state.token,
        },
        {
          validateStatus: () => true,
        }
      );

      if (disconnectResult.status >= 200 && disconnectResult.status < 300) {
        return true;
      } else {
        console.log(disconnectResult);
        return false;
      }
    },
    finchConnect() {
      const params = {
        client_id: process.env.VUE_APP_TRYFINCH_CLIENT_ID,
        products: "employment directory individual",
        redirect_uri: process.env.VUE_APP_TRYFINCH_REDIRECT_URI,
        sandbox: process.env.VUE_APP_TRYFINCH_SANDBOX_MODE === "true" ? "true" : "false",
      };
      const url =
        process.env.VUE_APP_TRYFINCH_API_BASE_URI + "/authorize?" + new URLSearchParams(params);
      // alert("at this point we open " + url);
      window.location.href = url;
    },

    async finishFinchConnect(code) {
      this.showLoadingDialog = true;
      this.loadingHeaderMessage = "Syncing users...";
      this.loadingMessageLine1 = "Currently syncing users from your HRIS. Thanks for waiting!";
      this.loadingMessageLine2 = "";
      try {
        const connectResult = await axios.post(
          process.env.VUE_APP_OAUTH_SVC_BASE_URI + "/finch/connect",
          {
            code,
            token: this.$store.state.token,
          },
          {
            validateStatus: () => true,
          }
        );

        // if (connectResult.status >= 200 && connectResult.status < 300) {
        // } else {
        //   console.log(connectResult);
        // }
        const FINCH_TAB = this.tabs.indexOf("Integrations");

        this.tab = FINCH_TAB;
        const result = connectResult.data;
        this.alert({
          title: "HRIS Connection",
          body: result.error
            ? result.error
            : `Successfully connected ${result.provider.display_name}. Onboarding will complete shortly.`,
        });
      } catch (e) {
        this.alert({
          title: "HRIS Connection",
          body: "Failed to establish HRIS connection. Please try again later.",
        });
      } finally {
        this.showLoadingDialog = false;
      }
    },
    async finchResync(data) {
      this.showLoadingDialog = true;
      this.loadingHeaderMessage = "Syncing users...";
      this.loadingMessageLine1 = "Currently syncing users from your HRIS. Thanks for waiting!";
      this.loadingMessageLine2 = "";
      try {
        const refreshResult = await axios.post(
          process.env.VUE_APP_OAUTH_SVC_BASE_URI + "/finch/refresh/" + data.clientSupplementalId,
          {
            token: this.$store.state.token,
          },
          {
            validateStatus: () => true,
          }
        );

        // if (refreshResult.status >= 200 && refreshResult.status < 300) {
        // } else {
        //   console.log(refreshResult);
        // }
        const FINCH_TAB = this.tabs.indexOf("Integrations");

        this.tab = FINCH_TAB;
        const result = refreshResult.data;
        this.alert({
          title: "HRIS Connection",
          body: result.error
            ? result.error
            : `Re-sync scheduled. Users will finish updating shortly.`,
        });
      } catch (e) {
        this.alert({
          title: "HRIS Connection",
          body: "Failed to establish HRIS connection. Please try again later.",
        });
      } finally {
        this.showLoadingDialog = false;
      }
    },
    async getFinchProviders(code) {
      const finchProviderResult = await axios.post(
        process.env.VUE_APP_OAUTH_SVC_BASE_URI + "/finch/providers",
        {
          code,
          token: this.token,
        },
        {
          validateStatus: () => true,
        }
      );

      if (finchProviderResult.status >= 200 && finchProviderResult.status < 300) {
        return finchProviderResult.data;
      } else {
        console.log(finchProviderResult);
      }
    },
    async getClients({ page, clientId }) {
      // Dispatch via the store if the user is not a whistle admin
      if (clientId && !this.clients.find((x) => x.clientId === clientId)) {
        await this.$store.dispatch("setUser", this.userProfile.userId);
        return;
      }

      console.log("getClients", { page, clientId });
      let apiPage = page || 0;
      const pageSize = 300;
      // console.log("Calling getClientsV2 for page ", apiPage);
      try {
        this.loading.clients = true;
        let clients = [];
        if (clientId) {
          let response = await this.clientService.getClientV3(clientId);
          if (response.result) {
            clients.push(response.result);
          }
        } else {
          let params = {
            limit: pageSize,
            offset: apiPage * pageSize,
            sort: "clientId ASC",
            includeClientRegistrationFormFields: true,
          };
          var response = await this.clientService.getClientsV3(params);
          clients = response.result.rows;
        }

        clients = clients.map((x) => {
          var obj = x;
          obj.formattedName = x.clientId + " - " + x.clientName;
          return obj;
        });

        if (apiPage == 0 && !clientId) {
          this.clients = clients;
        } else if (clientId) {
          // we have to replace an individual client in the array
          let clientIndex = this.clients.findIndex((x) => x.clientId == clientId);
          console.log("Updating individual client at index ", clientIndex);
          console.log(clients.length);
          if (clientIndex != -1 && clients.length == 1) {
            this.$set(this.clients, clientIndex, clients[0]);
            // this.clients[clientIndex] = clients[0];
          }
        } else {
          this.clients = this.clients.concat(clients);
        }
        if (!clientId && Number(this.clients.length) < Number(response.result.count)) {
          apiPage = apiPage + 1;
          this.getClients({ page: apiPage });
        } else {
          this.loading.clients = false;
          console.log("We've reached the end of the client list");
        }
      } catch (err) {
        console.log("Error getting clients ", err);
      }
      // }
    },
  },
  computed: {
    ...mapState(["permissions", "userProfile", "token", "roles", "globalClientId", "featureFlags"]),
    ...mapGetters(["hasPermissionToViewClients"]),
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
    showDeveloperSettingsTab() {
      return this.permissions.includes("vue:read:developer-settings");
    },
    showCompanyTab() {
      return this.permissions.includes("users:update:client");
    },
    showProcoreKickoff() {
      return this.permissions?.includes("procore:create:kickoff");
    },
    showMarqetaKYBTab() {
      return this.permissions.includes("marqeta:read:admin");
    },

    showDataIntegrationTab() {
      return (
        this.permissions.includes("prismatic:create:token") &&
        this.featureFlags["feature-prismatic"]
      );
    },
    currentClient() {
      return (
        this.clients.find((x) => x.clientId === this.globalClientId) || this.userProfile.Client
      );
    },
  },
  watch: {
    globalClientId: function (newVal) {
      this.currentClientId = newVal;
      console.log("globalClientId changed", newVal, this.currentClient);
    },
  },
};
</script>
<style>
.text {
  text-align: center;
  align-items: center;
}
.text-field {
  width: 50%;
  max-width: 50%;
}
.white-background {
  background-color: white;
}
</style>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
.brand-background {
  background-color: var(--v-brand-base);
}
.border-radius {
  border-radius: 5px;
}

.box-border {
  border: solid 1px;
  border-color: lightgray;
  border-radius: 0;
}

/* Removes gray header for document table */
.table >>> .v-data-table-header {
  background-color: white;
}

.view-button {
  line-height: 1.5;
  border-radius: 50px;
  height: 40px;
  margin-bottom: 14px;
  margin-top: 14px;
  padding: 0 0 0 16px !important;
}

.highlighted-button {
  background: #eeeeee !important;
}
</style>
